import React, { useCallback, useState } from "react";

import { Formik, Field, Form, ErrorMessage } from "formik";
import { IoIosArrowForward } from "react-icons/io";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { MdOutlinePersonOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import LoadingElevaty from "../../components/LoadingElevaty";
import { useVersion } from "../../Context/hasBetaActiveContext";
import { usePopup } from "../../Context/hasPopupActiveContext";
import { useAuth } from "../../hooks/AuthProvider";
import { useClient } from "../../hooks/ClientProvider";
import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import * as S from "./style";

function NewLogin() {
  const [hidePass, setHidePass] = useState(false);
  const [recoveyPass, setRecoveryPass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { signIn } = useAuth();
  const { fetchHasBetaActive } = useVersion();
  const { fetchHasPopupActive } = usePopup();

  const { clearClient } = useClient();
  const navigate = useNavigate();

  const isAllowAccess = JSON.parse(
    localStorage.getItem("@SnxPayment:allowAccess")
  );

  const RecoveryComponent = () => {
    const sendRecoveryEmail = useCallback(async (data) => {
      try {
        await api.post("send_recovery_password", {
          recovery_user: data.recovery_user,
        });

        setTimeout(() => {
          setRecoveryPass(false);
          notifySucces("E-mail de recuperação enviado");
        }, 1000);
      } catch (err) {
        notifyError(err.message, "LOGIN_ERROR");
      }
    }, []);

    return (
      <>
        <div className="content-login__title">
          <p className="title">Recuperação de senha</p>

          <p className="tagline">Digite o usuário para recuperação da senha</p>
        </div>

        <div className="content-login__form">
          <Formik
            initialValues={{ recovery_user: "" }}
            validationSchema={Yup.object({
              recovery_user: Yup.string().required("Informe o usuário"),
            })}
            onSubmit={sendRecoveryEmail}
          >
            <Form>
              <div className="content-login__form-item">
                <Field name="recovery_user">
                  {({ field, meta }) => (
                    <>
                      <p>Usuário</p>
                      <input
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        type="text"
                        placeholder="Insira o usuário"
                        {...field}
                      />
                      <div className="icone-input">
                        <MdOutlinePersonOutline />
                      </div>
                    </>
                  )}
                </Field>
                <ErrorMessage
                  name="recovery_user"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="content-login__btn-recovery">
                <button
                  type="button"
                  className="back-btn"
                  onClick={() => setRecoveryPass(false)}
                >
                  Voltar
                </button>
                <button type="submit" className="adjust-submit">
                  Enviar
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </>
    );
  };

  const handleSubmit = useCallback(
    async (data) => {
      try {
        setIsLoading(true);
        await signIn({ login: data.login, password: data.password });

        if (
          JSON.parse(localStorage.getItem("@SnxPayment:allowAccess")) === false
        ) {
          navigate("/access-denied");
          notifyError("Acesso negado");
          return;
        }

        navigate("/home");
        notifySucces("Logado com sucesso");
        await fetchHasPopupActive();
        await fetchHasBetaActive();

        clearClient();

        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } catch (err) {
        setIsLoading(false);

        notifyError(err.message, "LOGIN_ERROR");
      }
    },
    [clearClient, navigate, signIn]
  );

  return (
    <>
      {isLoading === true ? (
        <S.WrapperNewLoading>
          <LoadingElevaty />
        </S.WrapperNewLoading>
      ) : (
        <S.WrapperNewLogin>
          <div className="content-login">
            <div className="content-login__left">
              <div style={{ width: "100%" }}>
                <div className="content-login__logo">
                  <div className="content-login__logo-left">
                    <img src="/images/logo_rpe.png" alt="RPE" />
                  </div>
                  <div className="content-login__logo-right">
                    {/* <p>atendimento</p> */}
                  </div>
                </div>

                {recoveyPass ? (
                  <RecoveryComponent />
                ) : (
                  <>
                    <div className="content-login__title">
                      <p className="title">
                        Seja bem-vindo(a) a nossa plataforma de Atendimento
                      </p>

                      <p className="tagline">
                        Insira o seus dados de login para acessar o ambiente
                      </p>
                    </div>

                    <div className="content-login__form">
                      <Formik
                        initialValues={{ login: "", password: "" }}
                        validationSchema={Yup.object({
                          login: Yup.string().required("Informe o login"),
                          password: Yup.string().required("Senha obrigatória"),
                        })}
                        onSubmit={handleSubmit}
                      >
                        <Form>
                          <div className="content-login__form-item">
                            <Field name="login">
                              {({ field, meta }) => (
                                <>
                                  <p>Usuário</p>
                                  <input
                                    className={
                                      meta.touched && meta.error
                                        ? "error-id"
                                        : null
                                    }
                                    type="text"
                                    placeholder="Insira o usuário"
                                    {...field}
                                  />
                                  <div className="icone-input">
                                    <MdOutlinePersonOutline />
                                  </div>
                                </>
                              )}
                            </Field>
                            <ErrorMessage
                              name="login"
                              component="div"
                              className="error-message"
                            />
                          </div>
                          <div className="content-login__form-item">
                            <Field name="password">
                              {({ field, meta }) => (
                                <>
                                  <p>Senha</p>
                                  <input
                                    className={
                                      meta.touched && meta.error
                                        ? "error-id"
                                        : null
                                    }
                                    type={hidePass ? "text" : "password"}
                                    placeholder="Insira sua senha"
                                    {...field}
                                  />
                                  <div
                                    className="icone-input check"
                                    onClick={() => setHidePass(!hidePass)}
                                  >
                                    {hidePass ? (
                                      <IoEyeOffOutline />
                                    ) : (
                                      <IoEyeOutline />
                                    )}
                                  </div>
                                </>
                              )}
                            </Field>
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="error-message"
                            />
                          </div>

                          <div className="content-login__form-recovery">
                            <button
                              type="button"
                              onClick={() => setRecoveryPass(true)}
                            >
                              Esqueci minha senha <IoIosArrowForward />
                            </button>
                          </div>

                          <button type="submit" disabled={isLoading}>
                            Entrar
                          </button>
                        </Form>
                      </Formik>
                    </div>
                  </>
                )}
              </div>

              <div className="content-login__benefits">
                <a
                  href="https://br.linkedin.com/company/rpe-retail-payment-ecosystem"
                  target="_blank"
                >
                  Conheça as vantagens da RPE <IoIosArrowForward />
                </a>
              </div>
            </div>

            <div className="content-login__right" />
          </div>
        </S.WrapperNewLogin>
      )}
    </>
  );
}

export default NewLogin;
